import { Container, FlexBox } from "@components/wrapper"
import { SchoolBatch } from "@interfaces/school"
import { createMarkup, dateFormatter } from "@lib/functions"
import clsx from "clsx"
import React, { useEffect, useState } from "react"
import { BootcampHeading } from "../general/ProgramHeading"

interface ProgramSchedulesProps {
  batches?: SchoolBatch[]
  scroll: (link: string) => () => void
}

export const BootcampSchedule = ({ batches, scroll }: ProgramSchedulesProps) => {
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  return (
    <div className="bg-[#003BB7] sm:py-20 py-10 relative">
      <Container>
        <div className="sm:mb-9 mb-6 relative">
          <BootcampHeading
            title="Jadwal Bootcamp"
            subTitle="Lihat Batch yang Masih Tersisa di Sini!"
            id="schedule"
            type="white"
          />
        </div>

        <div className="grid sm:grid-cols-3 sm:gap-8 gap-3">
          {batches.map((batch) => (
            <div
              key={batch.batch}
              className={clsx("bg-white rounded-lg card-box grid gap-4.5", "sm:p-[28px] p-4")}
            >
              <FlexBox className="gap-4" justify="between" align="center">
                <div
                  className={clsx(
                    "font-urbanist sm:text-xl font-bold",
                    batch.batch_status === "SOLD_OUT" ? "text-disabled-grey" : "text-primary-black"
                  )}
                >
                  Batch {batch.batch}
                </div>

                <div
                  className={clsx(
                    "text-xs rounded p-2.5 h-fit font-bold",
                    batch.batch_status === "SOLD_OUT" && "text-error error-background",
                    batch.batch_status === "LIMITED_SEAT" && "text-[#FFB400] warning-background",
                    batch.batch_status === "OPEN_REGISTRATION" &&
                      "text-new-green success-background"
                  )}
                >
                  {batch.batch_status === "SOLD_OUT" && "Sold Out 😭"}
                  {batch.batch_status === "OPEN_REGISTRATION" && "Tersedia 👋"}
                  {batch.batch_status === "LIMITED_SEAT" && "Hampir Habis 🔥"}
                </div>
              </FlexBox>

              {isClient && (
                <table className="table-schedule">
                  <tr>
                    <td>
                      <FlexBox className="gap-2">
                        <span>📋</span>
                        <span className="text-secondary-grey">Pendaftaran</span>
                      </FlexBox>
                    </td>
                    <td className="text-new-green font-bold sm-only:text-sm">
                      {dateFormatter(batch.open_registration, "DD MMM YYYY")} -{" "}
                      {dateFormatter(batch.close_registration, "DD MMM YYYY")}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <FlexBox className="gap-2">
                        <span>🧑‍💻 </span>
                        <span className="text-secondary-grey">Kelas Dimulai</span>
                      </FlexBox>
                    </td>
                    <td className="text-new-green font-bold">
                      {dateFormatter(batch.batch_start, "DD MMMM YYYY")}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <FlexBox className="gap-2">
                        <span>🗓️ </span>
                        <span className="text-secondary-grey">Jadwal</span>
                      </FlexBox>
                    </td>
                    <td>
                      <div dangerouslySetInnerHTML={createMarkup(batch.batch_study_schedule)} />
                    </td>
                  </tr>
                </table>
              )}

              <FlexBox justify="end">
                {batch.batch_status !== "SOLD_OUT" ? (
                  <button className="text-new-blue underline" onClick={scroll("fee")}>
                    Daftar
                  </button>
                ) : (
                  <div className="underline text-disabled-grey">Closed</div>
                )}
              </FlexBox>
            </div>
          ))}
        </div>
      </Container>
    </div>
  )
}
